// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"439":"9e20d3b9","453":"d855a71b"}[chunkId] + ".chunk.js";
};